/* globals INITIAL_STATE */
import * as ActionTypes from '../actions/SettingsActions';
import * as InitializePurchaseActionTypes from '../actions/InitializePurchaseActions';
import * as SocialPayActionTypes from '../actions/SocialPayActions';
import * as RefinePurchaseActionTypes from '../actions/RefinePurchaseActions';
import * as InstapayActionTypes from '../actions/InstapayActions';
import * as PostPurchaseActionTypes from '../actions/PostPurchaseActions';
import { TABS } from '../constants/SettingsConstants';
import { getInitialStateTotalAmount, getAccordianHeading } from '../utils/GlobalUtils';
import { camelCaseKeys } from 'config/utils';
import { sanitizePaymentOptions } from './finalize/paymentOptions';
import root from 'window-or-global';

import {
  getIsMobileDevice,
} from 'utils/ModernizrUtils';

function settings (state = getInitialState(INITIAL_STATE), action) {
  switch (action.type) {
    // case ActionTypes.HANDLE_CLOSE_TAB: {
    //   const { tab } = action.payload;
    //   let updateWith = {};
    //   if (tab === TABS.INITIALIZE) {
    //     updateWith = { ...updateWith, isInitializeFormOpen: false };
    //     if (state.isShowRefinePurchaseBox) {
    //       updateWith = { ...updateWith, isRefineFormOpen: true, isFinalizeFormOpen: false };
    //     } else {
    //       updateWith = { ...updateWith, isFinalizeFormOpen: true };
    //     }
    //   }
    //
    //   return {
    //     ...state,
    //     ...updateWith,
    //   };
    // }
    //
    // case ActionTypes.HANDLE_OPEN_TAB: {
    //   // const { tab } = action.payload;
    //   return state;
    // }

    case ActionTypes.HANDLE_TOGGLE_OPEN_STATE: {
      const { tab, isOpen } = action.payload;
      if (!isOpen) {
        // we don't support closing the tab right now.
        // since atleast one form has to be open at all times.
        return state;
      }

      const orderOfTabs = ['isInitializeFormOpen', 'isRefineFormOpen', 'isFinalizeFormOpen', 'isFinalizeSocialPayFormOpen'];

      let updateWith = {};
      let allTabs = Object.keys(TABS).map(tab => TABS[tab]);
      // delete this tab from the tabs that need to be nuked
      allTabs.splice(allTabs.indexOf(tab), 1);

      const otherTabsUpdate = allTabs.reduce((markFalse, tab) => {
        markFalse[`is${tab}FormOpen`] = false;
        return markFalse;
      }, {});

      const handledTab = `is${tab}FormOpen`;

      // if `tab` is getting open, close all other tabs
      updateWith = {
        [handledTab]: true,
        ...otherTabsUpdate,
      };

      const currentlyOpenTabIndex = orderOfTabs.indexOf(orderOfTabs.find(tab => state[tab]));
      updateWith = {
        ...updateWith,
        isBackwardMotion: currentlyOpenTabIndex > orderOfTabs.indexOf(handledTab),
      };

      return {
        ...state,
        ...updateWith,
      };
    }

    case ActionTypes.HANDLE_TOGGLE_PAYMENT_POPUP: {
      const toggleState = !state.isPaymentPopupOpen;
      root.isPaymentButtonClicked = toggleState;
      return {
        ...state,
        isPaymentPopupOpen: toggleState,
      };
    }

    case ActionTypes.HANDLE_TOGGLE_INITIALIZE_FORM_ANIMATED: {
      return {
        ...state,
        isInitializeFormAnimated: !state.isInitializeFormAnimated,
      };
    }

    case ActionTypes.SHOW_DEFERRED_MERCHANT_HEADER: {
      return {
        ...state,
        showDeferred: true,
      };
    }

    case ActionTypes.HANDLE_AWAITING_PAYMENT_COMPLETION: {
      return {
        ...state,
        isAwaitingPaymentCompletion: action.waitingStatus,
      };
    }

    case InitializePurchaseActionTypes.HANDLE_SET_TOTAL_AMOUNT: {
      const { totalAmount } = action.payload;
      const shippingCharges = INITIAL_STATE.is_shipping_charges_enabled;
      const shippingDefault = INITIAL_STATE.initial_shipping_charges;

      let mergeWith = {
        ...state,
        totalAmount,
      };

      //Hide the finalize purchase box ONLY when shipping charges are disabled and total amount is 0.
      //Total amount DOES NOT include shippingCharges.
      if (!totalAmount && !shippingCharges && !shippingDefault) {
        return {
          ...mergeWith,
          isShowFinalizePurchaseBox: false,
        };
      }

      return {
        ...mergeWith,
        isShowFinalizePurchaseBox: true,
        isShowFinalizeSocialPayBox: false,
      };
    }

    case InitializePurchaseActionTypes.HANDLE_SET_ACCORDIAN_HEADING: {
      const { heading } = action.payload;
      return {
        ...state,
        initializeHeading: heading,
      };
    }

    case InitializePurchaseActionTypes.HANDLE_SUBMIT_INITIALIZE_PURCHASE_SUCCESS: {
      const fieldsWithNoPayment = [
        'claimUri',
        'socialpayUri',
      ];

      const {
        details,
      } = action.response;

      // if no payment is required, then stay in the same tab
      if (fieldsWithNoPayment.find(field => details[field])) {
        return state;
      }

      // refactor incoming options to suit new ways
      //
      const sanitizedPaymentOptions = sanitizePaymentOptions(details);

      // if paymentOptions are sent as part of this action, move to last step
      if (sanitizedPaymentOptions.paymentOptions && Object.keys(sanitizedPaymentOptions.paymentOptions).length) {
        return {
          ...state,
          isInitializeFormOpen: false,
          isInitializeFormOpenable: true,
          isFinalizeFormOpenable: true,
          isFinalizeFormOpen: true,
          isBackwardMotion: false,
        };
      }

      // regular flow. move to custom fields.
      return {
        ...state,
        isInitializeFormOpen: false,
        isInitializeFormOpenable: true,
        isRefineFormOpen: true,
        isRefineFormOpenable: true,
        isBackwardMotion: false,
      };
    }

    case RefinePurchaseActionTypes.HANDLE_SUBMIT_REFINE_PURCHASE_SUCCESS: {
      const {
        details: {
          socialpayUri,
          claimUri,
        },
      } = action.response;

      if (socialpayUri || claimUri) {
        return state;
      }
      return {
        ...state,
        isInitializeFormOpen: false,
        isRefineFormOpen: false,
        isFinalizeFormOpen: true,
        isFinalizeFormOpenable: true,
        isBackwardMotion: false,
      };
    }

    /* Initialize Purchase Details should be server validated before moving to the next steps */
    case InitializePurchaseActionTypes.HANDLE_IP_CHANGE_INPUT: {
      return {
        ...state,
        isRefineFormOpenable: false,
        isFinalizeFormOpenable: false,
        isFinalizeSocialPayFormOpenable: false,
      };
    }

    /* Refine Purchase Details should be server validated before moving to the next steps */
    case RefinePurchaseActionTypes.HANDLE_CHANGE_RP_INPUT: {
      return {
        ...state,
        isFinalizeFormOpenable: false,
        isFinalizeSocialPayFormOpenable: false,
      };
    }

    case SocialPayActionTypes.HANDLE_SOCIALPAY_AUTH_CALLBACK: {
      const { socialPayCallbackData } = action.payload;
      if (socialPayCallbackData) {
        return {
          ...state,
          isFinalizeSocialPayFormOpenable: true,
          isFinalizeSocialPayFormOpen: true,
          isInitializeFormOpen: false,
          isInitializeFormOpenable: true,
          isRefineFormOpen: false,
          isRefineFormOpenable: true,
        };
      }
      return state;
    }

    case InstapayActionTypes.HANDLE_SUBMIT_INSTAPAY_SUCCESS: {
      return {
        ...state,
        isInstapayInitiated: true,
        initializeHeading: getAccordianHeading('InitializePurchase', action.payload.amount),
      };
    }

    case InstapayActionTypes.HANDLE_CHANGE_INSTAPAY_FORM: {
      return {
        ...state,
        isInstapayInitiated: false,
        isInitializeFormOpen: true,
        isFinalizeFormOpen: false,
      };
    }

    case PostPurchaseActionTypes.RETRY_FAILED_PAYMENT: {
      const { responseType } = state;
      const commonStateSettings = {
        isRetrying: true,
        isPaymentResponse: false,
        isPaymentPopupOpen: true,
        isInitializeFormOpen: false,
        isInitializeFormOpenable: false,
        isShowInitializePurchaseBox: false,
        isFinalizeFormOpen: true,
        showDeferred: true,
        isOfferAvailable: true,
      };

      if (responseType == 'product' || responseType == 'cart') {
        return {
          ...state,
          ...getOfferInitialState(INITIAL_STATE),
          ...commonStateSettings,
          isShowFinalizePurchaseBox: true,
          isFinalizeFormOpenable: true,
          isShowRefinePurchaseBox: false,
        };
      }
      else if (responseType == 'instapay') {
        return {
          ...state,
          ...getInstapayInitialState(INITIAL_STATE),
          ...commonStateSettings,
          isInstapayInitiated: true,
        };
      }
      else if (responseType == 'link') {
        return {
          ...state,
          ...getLinkInitialState(INITIAL_STATE),
          ...commonStateSettings,
        };
      }
    }

    default:
      return state;
  }
}

export default settings;

const getOfferInitialState = (state) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const {
    show_additional_info_tab: isShowRefinePurchaseBox,
    show_payment_tab: isShowFinalizePurchaseBox,
    is_direct_to_payments: isDirectToPayments,
    is_embed: isEmbed,
    im_branding: imBranding,
    is_iframe: isIFrame,
    show_socialpay_tab: isShowFinalizeSocialPayBox,
    show_convenience_fee: showConvenienceFee,
    is_international_enabled: isInternationalNumberEnabled,
    is_shipping_charges_enabled: isShippingChargesEnabled,
    offer: {
      is_available: isOfferAvailable,
      avatar: sellerAvatar,
      seller,
      payment_forms,
      initial_shipping_charges: initialShippingCharges,
    },
  } = shouldRetry ? state.retry_data : state;

  const initialTotalAmount = getInitialStateTotalAmount();
  const initialState = {
    isLinkPayment: false,
    isOfferAvailable,
    isPaymentPopupOpen: false,
    totalAmount: initialTotalAmount,
    isInitializeFormOpen: true,
    isInitializeFormOpenable: true,
    isInitializeFormAnimated: getIsMobileDevice() || (isEmbed && isIFrame),
    initializeHeading: getAccordianHeading('InitializePurchase', initialTotalAmount),
    isRefineFormOpen: false,
    isRefineFormOpenable: false,
    isRefineFormAnimated: true,
    refineHeading: getAccordianHeading('RefinePurchase', initialTotalAmount),
    isFinalizeFormOpen: false,
    isFinalizeFormOpenable: false,
    isFinalizeFormAnimated: true,
    finalizeHeading: getAccordianHeading('FinalizePurchase', initialTotalAmount),
    isFinalizeSocialPayFormOpen: false,
    isFinalizeSocialPayFormOpenable: false,
    isFinalizeSocialPayFormAnimated: true,
    isShowInitializePurchaseBox: true,
    isShowRefinePurchaseBox,
    isShowFinalizePurchaseBox: !!((initialTotalAmount && isShowFinalizePurchaseBox) || (isShippingChargesEnabled && initialShippingCharges)),
    isShowFinalizeSocialPayBox,
    socialPayHeading: 'Social Pay',
    isEmbed,
    imBranding,
    showConvenienceFee,
    isInternationalNumberEnabled,
    isIFrame,
    isMobileDevice: getIsMobileDevice(),
    seller: camelCaseKeys(seller),
    sellerAvatar,
    isOfferDetailsFormOpen: false,
    isBackwardMotion: false,
    showDeferred: false,
  };

  if (isDirectToPayments && initialTotalAmount) {
    return {
      ...initialState,
      isInitializeFormOpen: false,
      isInitializeFormOpenable: false,
      isShowFinalizePurchaseBox: true,
      isShowInitializePurchaseBox: false,
      isFinalizeFormOpen: true,
      isFinalizeFormOpenable: true,
      isShowRefinePurchaseBox: false,
    };
  }

  return initialState;
};

const getLinkInitialState = (state) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const {
    is_embed: isEmbed,
    is_iframe: isIFrame,
    is_owner: isOwner,
    im_branding: imBranding,
    show_convenience_fee: showConvenienceFee,
    is_international_enabled: isInternationalNumberEnabled,
    link: {
      amount: initialTotalAmount,
      title: title,
    },
    seller: {
      avatar: sellerAvatar,
      username,
      name,
    },
  } = shouldRetry ? state.retry_data : state;

  return {
    isLinkPayment: true,
    isMerchantViewingOwnLink: isOwner,
    isOfferAvailable: true,
    isPaymentPopupOpen: true,
    totalAmount: initialTotalAmount,
    isInitializeFormOpen: true,
    isInitializeFormOpenable: true,
    isInitializeFormAnimated: getIsMobileDevice() || (isEmbed && isIFrame),
    initializeHeading: getAccordianHeading('InitializePurchase', initialTotalAmount),
    isFinalizeFormOpen: false,
    isFinalizeFormOpenable: false,
    isFinalizeFormAnimated: true,
    finalizeHeading: getAccordianHeading('FinalizePurchase', initialTotalAmount),
    isShowInitializePurchaseBox: true,
    isShowRefinePurchaseBox: false,
    isShowFinalizePurchaseBox: true,
    isEmbed,
    isIFrame,
    imBranding,
    showConvenienceFee,
    isInternationalNumberEnabled,
    isMobileDevice: getIsMobileDevice(),
    sellerAvatar,
    seller: {
      username,
      name,
    },
    isBackwardMotion: false,
    showDeferred: false,
    title,
  };
};

const getInstapayInitialState = (state) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const {
    is_embed: isEmbed,
    is_iframe: isIFrame,
    im_branding: imBranding,
    is_direct_to_payments: isDirectToPayments,
    is_rap: isRAP,
    show_convenience_fee: showConvenienceFee,
    is_international_enabled: isInternationalNumberEnabled,
    seller: {
      username,
      avatar,
      name,
    },
    payment_forms,
    prefilled: {
      amount,
    } = {},
  } = shouldRetry ? state.retry_data : state;

  const initialState = {
    isInstapayPayment: true,
    isRAP,
    isEmbed,
    isIFrame,
    imBranding,
    showConvenienceFee,
    isInternationalNumberEnabled,
    isOfferAvailable: true,
    isPaymentPopupOpen: true,
    isInitializeFormOpen: true,
    isInitializeFormOpenable: true,
    isFinalizeFormOpenable: false,
    isShowInitializePurchaseBox: true,
    isShowFinalizePurchaseBox: true,
    initializeHeading: getAccordianHeading('InitializePurchase', amount),
    finalizeHeading: getAccordianHeading('FinalizePurchase', amount),
    sellerAvatar: avatar,
    seller: {
      username,
      name,
    },
  };

  if (isDirectToPayments) {
    return {
      ...initialState,
      isInitializeFormOpen: false,
      isInitializeFormOpenable: false,
      isShowInitializePurchaseBox: false,
      isFinalizeFormOpen: true,
      isDirectToPayments,
    };
  }

  return initialState;
};

const getResponseInitialState = (state) => {
  return {
    isPaymentResponse: true,
    responseType: state.response_type,
    isCartOrder: state.payment.is_cart_order,
    isPaymentPopupOpen: true,
    isRetryEnabled: state.should_retry,
    hasFailureRedirection: state.has_failure_redirection,
    isRetrying: false,
    shouldShowPaymentOptionsDirectlyOnRetry: state.direct_to_payments,
  };
};

const getInitialState = (state) =>
  state.is_payment_response ?
    getResponseInitialState(state) :
    state.is_link_payment ?
      getLinkInitialState(state) :
        state.is_instapay_payment ?
          getInstapayInitialState(state) :
            state.offer ?
            getOfferInitialState(state) :
            {};



// WEBPACK FOOTER //
// ./src/payments/reducers/SettingsReducers.js